import { createFileRoute, redirect } from '@tanstack/react-router';

import { QuantitySelectionStep } from '@apple/features/cart-retail/components/steps/quantities';

export const Route = createFileRoute('/_authed/cart/_steps/quantities')({
	beforeLoad: ({
		context: {
			auth: { profile },
		},
	}) => {
		if (profile?.singleStoreAccess) {
			throw redirect({
				to: '/cart/products',
				replace: true,
			});
		}
	},
	component: RouteComponent,
	wrapInSuspense: true,
});

function RouteComponent() {
	return <QuantitySelectionStep />;
}
